import { FC } from 'react'

import { Container } from 'designSystem'

export const NotFoundPage: FC = () => (
  <Container pa={8} jc="center">
    Not Found
  </Container>
)
